import ROLES from '../roles'
import config from '../../config'

const _permissions = _role => {
  let result = {}

  _role.forEach(r => {
    const rules = config.rolesPermissions.filter(permission => {
      const role = ROLES[r]

      if (permission.role === role) return permission
    })

    if (rules.length) result = rules[0]
  })

  return result
}

export const userService = (data = '', role = '') => {
  return {
    login: () => {
      window.localStorage.setItem('_x', JSON.stringify(data.id_token))
      return true
    },

    logout: () => {
      window.localStorage.clear()
      return true
    },

    perfil: () => ROLES[role],

    filtersForProfileDrop: () => {
      const filters = _permissions(role)
      return Object.keys(filters).length ? filters.type : filters
    },

    showDriverTab: () => {
      const show = _permissions(role)
      return Object.keys(show).length ? show.activeDriverTab : false
    },

    showDropPartner: () => {
      const show = _permissions(role)
      return Object.keys(show).length ? show.activeDropPartner : false
    },

    titleTab: () => {
      const show = _permissions(role)
      return Object.keys(show).length ? show.titleTab : false
    },

    showAdmin: () => {
      const show = _permissions(role)
      return Object.keys(show).length ? show.menu.showAdmin : false
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/userService.js